export default __webpack_public_path__ + "b19696fc6786627d2686f2aaa21f1b8e.png";